module.exports = __webpack_public_path__ + "img/mastercard_visa_icon.686aaf67.svg";